import {CustomChart} from "../../../../components";
import {useAppTranslation} from "../../../../constants";

interface ForearmPronationChartProps {
    stats: {
        feelingStats: any,
        handStats: any
    }
}

export const ForearmPronationChart = (props: ForearmPronationChartProps) => {
    const { t } = useAppTranslation();

    const max = Math.abs(props.stats.handStats.healthyHand.leftMax) || 0.4;
    const min = 0;

    const data = props.stats.feelingStats.data.map((d: any) => {
        const measures = d.measures.filter((m: any) => m.exerciseIndex === 9);
        if (measures.length === 0) {
            return null
        }
        let value = (Math.abs(measures[measures.length - 1].measuredData.leftMax) - min) / (max - min);
        if (value > 1) {
            value = 1;
        }
        if (value < 0) {
            value = 0;
        }
        return {
            day: d.day,
            value: Math.round(value * 90 * 100) / 100
        }
    }).filter((d: any) => d !== null)
    if (data.find((d: any) => d.day === 1) === undefined) {
        data.push({ day: 1, value: null })
    }
    if (data.find((d: any) => d.day === 60) === undefined) {
        data.push({ day: 60, value: null })
    }
    data.sort((a: any, b: any) => a.day - b.day);

    return (
        <CustomChart
            type="line"
            chartId="pain-after"
            dateTimes={data.map((data: any) => `Day ${ data.day }`)}
            minSeriesName=""
            minData={data.map((data: any) => data.value)}
            width={"548"}
            height={"400"}
            chartTitle={t("forearm-pronation-chart-title")}
            stepperTitle={""}
            poz="top"
            max={90}
            min={0}
            markerSize={4}
        />
    )
}